module.exports = __webpack_public_path__ + "media/application/images/svgs/gift-6731922b4c30a85847d483769d1cfa8f.svg";